import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-default/index.css";
import './styles/index.css';
import axios from "axios";
import VueResource from "vue-resource";
import VueRouter from "vue-router";
import router from "./router/index.js";
import store from "../vuex/index";
import App from "./App.vue";
import util from "./common/public.js";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

// main外层布局
import BaseContainer from './components/common/BaseContainer.vue';
// 通用上传组件（el-upload 封装，支持 size 限制 + v-model 绑定文件列表）
import SUpload from './components/common/SUpload.vue';

// 开启debug模式
Vue.config.debug = true;
Vue.prototype.$axios = axios;
Vue.prototype.$util = util;

// dayjs 全局注册：脚本里 this.$dayjs，模板里 $dayjs，无需各自 import
// duration 插件随全局一并注册（倒计时格式化用）
dayjs.extend(duration);
Vue.prototype.$dayjs = dayjs;

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(ElementUI);
Vue.component('BaseContainer', BaseContainer)
Vue.component('SUpload', SUpload)

Vue.http.options.xhr = {
  withCredentials: true,
  contentType: "application/json;charset=UTF-8",
  datatype: "json",
};

// vue-resource 拦截器
Vue.http.interceptors.push((request, next) => {
  request.credentials = true;
  next((response) => {
    if (response.status === 403) {
      store.dispatch("SIGNOUT");
      location.href = "/#";
    }
  });
});

// 路由跳转前验证是否登录，如果没有则重定向到登录页
router.beforeEach(({ path }, from, next) => {
  let isLogin = Boolean(store.state.user.name);
  if (!isLogin && path !== "/login") {
    return next({ path: "/login" });
  }
  next();
});

// 现在我们可以启动应用了！
// 路由器会创建一个 App 实例，并且挂载到选择符 #app 匹配的元素上。
const app = new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js